import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=8e2b11f6&scoped=true&"
import script from "./brief.vue?vue&type=script&lang=js&"
export * from "./brief.vue?vue&type=script&lang=js&"
import style0 from "./brief.vue?vue&type=style&index=0&id=8e2b11f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2b11f6",
  null
  
)

export default component.exports